import React from "react";
import { NavLink } from 'react-router-dom';
import '../scss/Landing.css';

const LandingPage = () =>{
    return(
        <div className="landingPage">
            <div className="left">
                <p className="tag">Online Educational Resource Platform</p>
                <p className="heading">Classromm Bucket</p>
                <p className="bottomtag"> - Everything in one Bucket </p>
          <NavLink to="/" exact className="s-item" title='Form' activeClassName="active"> <button>Dashboard <i class="fas fa-keyboard"></i></button>  </NavLink>

                
            </div>
            <div className="right">
                <img src="https://cdn3d.iconscout.com/3d/premium/thumb/study-from-book-6102705-5058811.png" alt="altimg" />
            </div>
        </div>
    )
}

export default LandingPage;